import React from 'react';
import styled from 'styled-components';
import { OptionItem } from '../optionItem';
const GroupItemsWrapper = styled.div `
  display: grid;
  grid-template-columns: calc(50% - 8px) calc(50% - 8px);
  grid-gap: 16px;
  margin: 16px 0;
  width: 100%;
`;
export const GroupOptionItems = ({ optionItems, updateOptions, version = 'v1', style }) => {
    const handleSelectedItem = (id) => {
        if (updateOptions) {
            updateOptions(id);
        }
    };
    return (React.createElement(GroupItemsWrapper, { style: style }, optionItems.map(item => (React.createElement(OptionItem, { key: item.id, id: item.id, text: item.text, value: item.value, isActive: item.isActive, disabled: item.disabled, onClick: () => handleSelectedItem(item.id), version: version })))));
};
//# sourceMappingURL=index.js.map